import type { CourseModule } from "@/core/types";
import { lektionSortieren } from "./lektion-01-sortieren";
import { lektionFiltern } from "./lektion-02-filtern";
import { lektionDuplikate } from "./lektion-03-duplikate";

export const modulSortieren: CourseModule = {
  id: "sortieren",
  title: "Sortieren, Filtern, Duplikate",
  summary:
    "Ordnung in die Daten bringen, ohne sie zu zerstören – und der Unterschied " +
    "zwischen einer Sicht auf die Daten und den Daten selbst.",
  level: "Grundlagen",
  lessons: [lektionSortieren, lektionFiltern, lektionDuplikate],
};
